import type { Color, PieceType } from './types'

/** 棋子文案：红方用帅仕相马车炮兵，黑方将士象马车炮卒。 */
export const LABELS: Readonly<Record<Color, Readonly<Record<PieceType, string>>>> = {
  r: { K: '帅', A: '仕', B: '相', N: '马', R: '车', C: '炮', P: '兵' },
  b: { K: '将', A: '士', B: '象', N: '马', R: '车', C: '炮', P: '卒' },
}